import React from 'react';
import { Briefcase, Users, RefreshCw } from 'lucide-react';
import { suitableFor } from '../data/mock';

const iconMap = {
  briefcase: Briefcase,
  users: Users,
  refresh: RefreshCw,
};

const SuitableForSection = () => {
  return (
    <section id="suitable-for" className="py-20 lg:py-28 bg-slate-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="inline-block bg-sky-500/20 text-sky-400 px-4 py-2 rounded-full text-sm font-semibold mb-4">
            Who This Is For
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-4">
            Suitable For
          </h2>
          <p className="text-lg text-slate-400 max-w-2xl mx-auto">
            This vehicle is available to experienced trade window cleaners only.
          </p>
        </div>

        {/* Cards */}
        <div className="grid md:grid-cols-3 gap-6 lg:gap-8">
          {suitableFor.map((item, index) => {
            const IconComponent = iconMap[item.icon];
            return (
              <div
                key={index}
                className="group relative bg-slate-800/50 hover:bg-slate-800 border border-slate-700 hover:border-sky-500/50 rounded-2xl p-8 transition-all duration-300 hover:shadow-xl hover:shadow-sky-500/10"
              >
                {/* Number Badge */}
                <div className="absolute -top-4 -left-4 w-8 h-8 bg-sky-600 rounded-lg flex items-center justify-center text-white font-bold text-sm shadow-lg">
                  {index + 1}
                </div>

                <div className="w-16 h-16 bg-sky-500/20 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                  {IconComponent && <IconComponent className="w-8 h-8 text-sky-400" />}
                </div>
                
                <h3 className="text-xl lg:text-2xl font-bold text-white mb-3">{item.title}</h3>
                <p className="text-slate-400 leading-relaxed">{item.description}</p>
              </div>
            );
          })}
        </div>

        {/* Additional Info */}
        <div className="mt-12 text-center">
          <p className="text-slate-400 max-w-2xl mx-auto">
            Commercial and residential window cleaning. Short-term or longer-term agreements by arrangement.
          </p>
        </div>
      </div>
    </section>
  );
};

export default SuitableForSection;
